import { operationsVisibilityColumns } from '@operations/pages/list/components/OperationsDataSet/visibilityColumns';

import { type DataSetConfig } from '../types';

const initialOperationsConfig: DataSetConfig = {
  sorting: [],
  pagination: { pageSize: 20, pageIndex: 0 },
  columnsVisibility: operationsVisibilityColumns,
};

export { initialOperationsConfig };
